import { render } from "./TicketState.vue?vue&type=template&id=4c4fb0da&ts=true"
import script from "./TicketState.vue?vue&type=script&lang=ts"
export * from "./TicketState.vue?vue&type=script&lang=ts"

import "./TicketState.vue?vue&type=style&index=0&id=4c4fb0da&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__